import { useAuthUser } from "../../../core_stores/useAuthStore";
import { useUserSubscription } from "../../../core_stores/useSubscriptionStore";
import { formatTokensCompact } from "../../../utils/numberFormatter";
import { useSideMenuActions } from "../../../view_stores/useSideMenuStore";

export default function SideMenuProfile() {
  const user = useAuthUser();
  const subscription = useUserSubscription();
  const { openPersonalSettings } = useSideMenuActions();

  return (
    <button
      className="w-full py-2 px-2 rounded-lg
        hover:bg-dark-hover cursor-pointer transition-colors"
      onClick={() => openPersonalSettings("plans")}
    >
      <div className="grid grid-cols-[28px_1fr] items-center gap-3">
        <img
          src={user?.photoURL || ""}
          alt="Profile"
          className="w-[28px] h-[28px] rounded-full object-cover"
          referrerPolicy="no-referrer"
        />
        <div className="min-w-0 text-left">
          <div className="text-sm font-medium text-dark-text truncate">
            {user?.displayName}
          </div>
          <div className="text-xs text-dark-text-muted">
            {subscription?.plan ?? "Dream"} (
            {formatTokensCompact(subscription?.remaining ?? 0)})
          </div>
        </div>
      </div>
    </button>
  );
}
